var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcConvenienceOn = function SvgIcConvenienceOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D85FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3 4h18v5H3zM4.5 10v10h15V10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D85FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8 13.667C8 12.833 8.375 12 9.5 12s1.5.833 1.5 1.667c0 .833-2.25 2-3 2.833h3M14.6 12 13 15.333h4m-1.2-1.666V16.5M3 6.5h18"
  })));
};
export default SvgIcConvenienceOn;